export const SAM_JOB_ID = 'SAM2ImageEncoder'
export const SAM_EMBEDDING_NAME = 'sam_2_1_large_v1'
export const SAM_MODEL_FILENAME = 'sam2.1_large.onnx'
export const SAM_TOOL_NAME = 'SamTool'
